@let libraryBlocks = libraryBlocks$ | async;
@let isAdmin = isAdmin$ | async;
@let isMobile = isMobile$ | async;
@let isEcommerceMode = isEcommerceMode$ | async;

@if (isMobile === false) {
    <div class="desktop-drawer">
        <div class="drawer-container" [class.opened]="showDrawer$ | async">
            <div class="drawer-container-header">
                <span class="close-icon text-muted" (click)="closeDrawer()">×</span>
            </div>

            <div class="btn-container">
                <a class="btn blue-btn btn-block" (click)="createBlock(blockIndex, isAdmin)">
                    {{ "empty_block" | translate }}
                </a>
            </div>

            @if (showZeroBlockButton$ | async) {
                <div class="btn-container">
                    <a
                        class="btn blue-btn btn-block"
                        [tooltip]="'zero_block_btn_tooltip' | translate"
                        placement="bottom"
                        (click)="createZeroBlock(blockIndex)"
                    >
                        <span class="sp-icon icon-frame"> </span> {{ "zero_block" | translate }}
                        <sup class="color-active">β</sup>
                    </a>
                </div>
            }

            @if (isAdmin) {
                <div class="btn-container">
                    <a class="btn blue-btn btn-block" (click)="createSpecificBlock(blockIndex)"> SPECIAL BLOCK </a>
                </div>
            }

            <ul class="block-category-list">
                <ng-container *ngFor="let category of categoriesOrder">
                    <li
                        *ngIf="
                            (isEcommerceMode !== true || category === widgetsCategoryKey) &&
                            (category === savedCategoryKey ? libraryBlocks[category]?.length : true)
                        "
                        [class]="getActiveClass(category)"
                        (click)="setActiveState(category)"
                    >
                        {{ categoryNames[category] }}
                        <span *ngIf="isSharedBlockCategory(category)" [tooltip]="'shared_block_tooltip' | translate">
                            <img src="./assets/img/websites/lpc-shared-block-icon.svg" alt="shared blocks" />
                        </span>
                    </li>
                </ng-container>
            </ul>
        </div>

        <div class="block-gallery-container" [class.opened]="showDrawer$ | async">
            <div class="container-fluid container-inner">
                <div *ngIf="isLoadingDrawer" class="preloader preloader-puff-rounds"></div>
                <div class="row">
                    <h3 class="col-xs-12">{{ categoryNames[activeCategory.value] }}</h3>
                    <ng-container
                        *ngFor="let blockItem of libraryBlocks[activeCategory.value] | spReverseArray; let i = index"
                    >
                        <div class="col-xs-12 blockItem mb-20">
                            <img
                                *ngIf="blockItem?.userId"
                                class="delete-icon"
                                src="./assets/img/websites/dropdown-menu/lpc-delete-dd-icon.svg"
                                alt="delete"
                                (click)="deleteBlockFromLibrary(blockItem)"
                            />
                            <img
                                class="block-preview-image"
                                [src]="blockItem.thumbnail"
                                (click)="createFromLibraryBlock(blockItem.content.structure)"
                            />
                        </div>
                    </ng-container>

                    <div *ngIf="activeCategory.value === widgetsCategoryKey" class="widgets-list-container col-xs-12">
                        <ng-container *ngIf="widgets$ | async as widgets">
                            <ng-container *ngIf="widgets | webWidgetGroup: 'common' as commonWidgets">
                                <h4 class="widgets-group-title" *ngIf="commonWidgets.length">
                                    {{ "widgets_group_common" | translate }}
                                </h4>
                                <div class="widgets-list">
                                    <web-toolbar-widget
                                        *ngFor="let widget of commonWidgets"
                                        [widget]="widget"
                                        [eduTariff]="eduUserTariff$ | async"
                                        [isAdmin]="isAdmin$ | async"
                                        [isEduSite]="isEduSite$ | async"
                                        (onClick)="createBlock(blockIndex, isAdmin, widget)"
                                    ></web-toolbar-widget>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="widgets | webWidgetGroup: 'course' as courseWidgets">
                                <h4 class="widgets-group-title" *ngIf="courseWidgets.length">
                                    {{ "widgets_group_courses" | translate }}
                                </h4>
                                <div class="widgets-list">
                                    <web-toolbar-widget
                                        *ngFor="let widget of courseWidgets"
                                        [widget]="widget"
                                        [eduTariff]="eduUserTariff$ | async"
                                        [isAdmin]="isAdmin$ | async"
                                        [isEduSite]="isEduSite$ | async"
                                        (onClick)="createBlock(blockIndex, isAdmin, widget)"
                                    ></web-toolbar-widget>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <div class="drawer-backdrop" [class.opened]="showDrawer$ | async" (click)="closeDrawer()"></div>
    </div>
} @else {
    <div class="mobile-drawer">
        <div class="drawer-container" [class.opened]="showDrawer$ | async">
            <div class="drawer-container-header">
                <span class="close-icon text-muted" (click)="closeDrawer()">×</span>
            </div>

            <ul class="block-category-list">
                <ng-container *ngFor="let category of categoriesOrder">
                    <li
                        *ngIf="isEcommerceMode !== true || category === widgetsCategoryKey"
                        (click)="setActiveStateOnMobile(category)"
                        [ngClass]="getActiveClass(category)"
                    >
                        {{ categoryNames[category] }}
                    </li>
                </ng-container>
            </ul>

            <div class="btn-container">
                <a class="btn blue-btn btn-block" (click)="createBlock(blockIndex, isAdmin)">{{
                    "empty_block" | translate
                }}</a>
            </div>
        </div>

        <div class="block-gallery-container" [class.opened]="(showDrawer$ | async) && showLibraryBlocksOnMobile">
            <div class="container-fluid container-inner">
                <div *ngIf="isLoadingDrawer" class="preloader preloader-puff-rounds"></div>
                <div class="row">
                    <h3 class="col-xs-12">
                        <img src="assets/img/websites/lpc-back-icon.svg" (click)="toggleLibraryBlocksMobile()" />
                        {{ categoryNames[activeCategory.value] }}
                    </h3>
                    <ng-container *ngFor="let blockItem of libraryBlocks[activeCategory.value]; let i = index">
                        <div class="col-xs-12 blockItem" (click)="createFromLibraryBlock(blockItem.content.structure)">
                            <img
                                *ngIf="blockItem?.userId"
                                class="delete-icon"
                                src="./assets/img/websites/dropdown-menu/lpc-delete-dd-icon.svg"
                                alt="delete"
                                (click)="deleteBlockFromLibrary(blockItem)"
                            />
                            <img class="block-preview-image" [src]="blockItem.thumbnail" alt="" />
                            <!-- <small class="text-muted">{{ blockItem.name }}</small> -->
                        </div>
                    </ng-container>

                    <div *ngIf="activeCategory.value === widgetsCategoryKey" class="widgets-list-container col-xs-12">
                        <ng-container *ngIf="widgets$ | async as widgets">
                            <ng-container *ngIf="widgets | webWidgetGroup: 'common' as commonWidgets">
                                <h4 class="widgets-group-title" *ngIf="commonWidgets.length">
                                    {{ "widgets_group_common" | translate }}
                                </h4>
                                <div class="widgets-list">
                                    <web-toolbar-widget
                                        *ngFor="let widget of commonWidgets"
                                        [widget]="widget"
                                        [eduTariff]="eduUserTariff$ | async"
                                        [isAdmin]="isAdmin$ | async"
                                        [isEduSite]="isEduSite$ | async"
                                        (onClick)="createBlock(blockIndex, isAdmin, widget)"
                                    ></web-toolbar-widget>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="widgets | webWidgetGroup: 'course' as courseWidgets">
                                <h4 class="widgets-group-title" *ngIf="courseWidgets.length">
                                    {{ "widgets_group_courses" | translate }}
                                </h4>
                                <div class="widgets-list">
                                    <web-toolbar-widget
                                        *ngFor="let widget of courseWidgets"
                                        [widget]="widget"
                                        [eduTariff]="eduUserTariff$ | async"
                                        [isAdmin]="isAdmin$ | async"
                                        [isEduSite]="isEduSite$ | async"
                                        (onClick)="createBlock(blockIndex, isAdmin, widget)"
                                    ></web-toolbar-widget>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <div class="drawer-backdrop" [class.opened]="showDrawer$ | async" (click)="closeDrawer()"></div>
    </div>
}
